module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M25.2 13.2L14.8 4.6V10H7.1c-1.4 0-2.5 1.3-2.5 2.9v.5c0 1.6 1.1 2.9 2.5 2.9h7.7v5.3l10.4-8.4z","fill":"#39b54a"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/redo.svg
// module id = 715
// module chunks = 2